<template>
  <ValidationProvider
      tag="div" :class="inline && 'd-flex flex-row'"
      :name="labelText" :rules="getRules()"
      :vid="vid" v-slot="{ errors }">
    <label v-if="!inline && !noLabel" :for="getId()">{{ capitalize(labelText) }}</label>
    <input
        type="time" :class="getInputFieldClass()"
        :id="getId()" :placeholder="'Voer ' + labelText + ' in'"
        v-model="inputVal"/>
    <div v-if="inline" class="pl-3 col-lg-8">
      <span class="text-red">{{ errors[0] }}</span>
    </div>
    <span v-else class="text-red">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
import {ValidationProvider} from "vee-validate";

export default {
  name: "TimeInputField",
  components: {
    ValidationProvider
  },
  props: {
    value: String,
    labelText: String,
    vid: String,
    inline: Boolean,
    noLabel: Boolean,
    required: Boolean,
    crossFieldRules: Array,
    id: String,
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        if (val || val === 0) {
          this.$emit('input', val);
        } else {
          this.$emit('input', undefined);
        }
      }
    }
  },
  methods: {
    getId() {
      return this.id || this.labelText;
    },
    capitalize(value) {
      if (!value) {
        return 0;
      }
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
    getRules() {
      const rules = [];

      if (this.required) {
        rules.push("required");
      }
      if (this.crossFieldRules) {
        this.crossFieldRules.forEach(rule => rules.push(rule));
      }

      return rules.join('|');
    },
    getInputFieldClass() {
      return this.inline ? "form-control col-lg-4" : "form-control";
    }
  }
};
</script>

<style scoped>

.text-red {
  color: red;
}

</style>